/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { LeverageSupplyOptions, LeverageSupplyResponses } from '../types/LeverageSupply'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Supply leverage for a specific asset
 * {@link /v1/leverage/supply}
 */
export function leverageSupply<ThrowOnError extends boolean = true>(
  options: Options<LeverageSupplyOptions, ThrowOnError>,
): Unwrappable<RequestResult<LeverageSupplyResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/leverage/supply',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LeverageSupplyResponses, ThrowOnError>>,
  )
}
